module.exports = __webpack_public_path__ + "Desktop-Homepage-Foreground.37c92798.png";


//////////////////
// WEBPACK FOOTER
// ./client/components/HomePage/Header/images/Desktop-Homepage-Foreground.png
// module id = 622
// module chunks = 0